import React from 'react'
import { Box } from '@mui/material'
import maintananceIMage from "../assets/images/maintainance.webp"

const Maintainance = () => {
    return (
        <Box
            sx={{
                height:"100vh",
                width:"100%",
                display:"flex",
                position:"absolute",
                zIndex:99999,
                top:0,
                right:0
            }}
        >
            <img src={maintananceIMage} style={{height:"100vh",
                width:"100%", margin:"auto auto"}} />
        </Box>
    )
}

export default Maintainance